class ProductSizeGuideTabs extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-size-guide-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-size-guide-panel]'));
    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.querySelector('.product-size-guide__tabs')?.setAttribute('role', 'tablist');
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', this.panels[index].id);
      this.panels[index].setAttribute('role', 'tabpanel');
      this.panels[index].setAttribute('tabindex', '0');
    });

    this.activate(0);
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      this.panels[tabIndex].hidden = !active;
    });
    if (focus) this.tabs[index].focus();
  }

  onClick(event) {
    const tab = event.target.closest('[data-size-guide-tab]');
    if (!tab || !this.contains(tab)) return;
    event.preventDefault();
    this.activate(this.tabs.indexOf(tab));
  }

  onKeydown(event) {
    const tab = event.target.closest('[data-size-guide-tab]');
    if (!tab || !this.contains(tab)) return;

    const index = this.tabs.indexOf(tab);
    let nextIndex;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!customElements.get('product-size-guide-tabs')) {
  customElements.define('product-size-guide-tabs', ProductSizeGuideTabs);
}
